import { AbstractReport } from '../abstract-report.model';
import { AccessorsMutatorsDecorator } from '../../../../helpers/model';

export class PaymentReconciliation extends AbstractReport {

}

AccessorsMutatorsDecorator(
    'user_id',
    'user_name',
    'amount',
    'pt_id',
    'payment_type',
    'payment_type_label',
    'is_credit_card',
    'credit_card_transactions',
)(PaymentReconciliation);



// WEBPACK FOOTER //
// ./src/pms-api/models/reports/daily-activity/payment-reconciliation.model.js